const env = window.env ?? process.env;
export const configuration = {
  NODE_ENV: env.NODE_ENV,
  API_URL: env.REACT_APP_API_URL,
  MINIO_URL: env.REACT_APP_MINIO_URL,
  CHAT_SOCKET_URL: env.REACT_APP_CHAT_SOCKET_URL,
  NOTIFICATION_SOCKET_URL: env.REACT_APP_NOTIFICATION_SOCKET_URL,
  OMNI_CHANNEL_SOCKET_URL: env.REACT_APP_OMNI_CHANNEL_SOCKET_URL,
  UPLOAD_SIZE_LIMIT_MB: env.REACT_APP_UPLOAD_SIZE_LIMIT_MB,
  OMNI_CHANNEL_CHAT_SESSION_LIMIT: env.REACT_APP_OMNI_CHANNEL_CHAT_SESSION_LIMIT,
  WORLD_PHONE_CONNECTION_URL: env.REACT_APP_WORLD_PHONE_CONNECTION_URL,
  REACT_APP_SCREEN_RECORDING_CONNECTION_URL: env.REACT_APP_SCREEN_RECORDING_CONNECTION_URL,
  AGENT_STATUS_ALERT_THRESHOLD_MINUTES: env.REACT_APP_AGENT_STATUS_ALERT_THRESHOLD_MINUTES,
  CHAT_SOCKET_PATH: env.REACT_APP_CHAT_SOCKET_PATH,
  NOTIFICATION_SOCKET_PATH: env.REACT_APP_NOTIFICATION_SOCKET_PATH,
  OMNI_CHANNEL_SOCKET_PATH: env.REACT_APP_OMNI_CHANNEL_SOCKET_PATH
};
